import { Box, CircularProgress } from '@mui/material';
import type { ActivityFeedListContext } from '../activityFeedList.types';

interface ActivityFeedListFooterProps {
  context: ActivityFeedListContext;
}

const ActivityFeedListFooter = ({ context }: ActivityFeedListFooterProps) => {
  if (!context.isLoadingMore) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 1.5 }}>
      <CircularProgress size={20} />
    </Box>
  );
};

export default ActivityFeedListFooter;
